"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.middleware = void 0;
var cj_1 = require("../cj");
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var cookies_1 = require("../cookies");
function middleware(request, response, next) {
    if ((0, cookies_1.hasAcceptedMarketingCookies)(request) && (0, cj_1.requestContainsCjQueryParams)(request)) {
        var fullUrl = (0, utils_1.buildFullUrlFromRequest)(request);
        var cje = new URL(fullUrl).searchParams.get(constants_1.CJ_QUERY_NAME);
        if (cje) {
            response.cookie(constants_1.CJ_COOKIE_NAME, cje, {
                path: "/",
                domain: (0, utils_1.getDomain)(),
                expires: (0, utils_1.addMonthstoDate)(new Date(), 13),
                sameSite: "none",
                secure: true,
            });
        }
    }
    next();
}
exports.middleware = middleware;
//# sourceMappingURL=express.js.map